import script from "./SharingLimitReachedModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SharingLimitReachedModal.vue?vue&type=script&lang=ts&setup=true"

import "./SharingLimitReachedModal.vue?vue&type=style&index=0&id=162a5f36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162a5f36"]])

export default __exports__